import React from 'react';
import { CampaignId, ChannelId, FeedId, SearchResult } from '@qualifio/data-search-api-client';
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { DataSearch, DataSearchProps } from '@qualifio/data-search-ui';
import { PathValue } from 'react-hook-form/dist/types/path/eager';
import { useApi } from '../../api-client/ApiClientProvider';

export type DataSearchFieldProps<FormValue, Name extends Path<FormValue> = Path<FormValue>> = Omit<
  DataSearchProps,
  'onChange' | 'value'
> & {
  name: Name; // FormValue[Path] = ChannelId | CampaignId;
  searchResultToValue: (
    result: SearchResult | null | undefined,
  ) => PathValue<FormValue, Name> | undefined;
  valueToSearchResult: (
    value: PathValue<FormValue, Name>,
  ) => ChannelId | CampaignId | FeedId | undefined;
  defaultValue?: string;
};

// TODO placeholder not visible and this isn't working: https://stackoverflow.com/questions/70624192/how-to-show-both-label-and-placeholder-in-material-ui-textfield
export function DataSearchField<
  FormValue extends FieldValues,
  Name extends Path<FormValue> = Path<FormValue>,
>({
  name,
  searchResultToValue,
  valueToSearchResult,
  defaultValue = '',
  ...dataSearchFieldProps
}: DataSearchFieldProps<FormValue, Name>) {
  const { control } = useFormContext<FormValue>();
  const { dataSearchApi } = useApi();
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue as any}
      render={({ field: { onChange, value, ...field } }) => (
        <DataSearch
          {...dataSearchFieldProps}
          {...(field as any)}
          dataSearchApi={dataSearchApi}
          value={valueToSearchResult(value)}
          onChange={result => {
            onChange(searchResultToValue(result));
          }}
        />
      )}
    />
  );
}
